import { pgTable, uuid, timestamp, primaryKey, index } from "drizzle-orm/pg-core";
import { customers } from "./customers.js";
import { products } from "./products.js";

// Persistent favorites for logged-in customers. Guest favorites live in
// localStorage on the storefront and get merged into this table on login.
// Table already exists in the DB (see initial migration); this is just the
// Drizzle binding.
export const customerFavorites = pgTable(
  "customer_favorites",
  {
    customerId: uuid("customer_id")
      .notNull()
      .references(() => customers.id, { onDelete: "cascade" }),
    productId: uuid("product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    pk: primaryKey({ columns: [t.customerId, t.productId] }),
    productIdx: index("customer_favorites_product_id_idx").on(t.productId),
  }),
);

export type CustomerFavorite = typeof customerFavorites.$inferSelect;
